package io.jsonize.web.navigation

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

class NavController(initial: Route = Route.Editor) {
    private val _current = MutableStateFlow<Route>(initial)
    val current: StateFlow<Route> = _current

    fun navigate(route: Route) {
        _current.value = route
    }

}

